import _toConsumableArray from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as tslib_1 from "tslib";
import { isArray } from 'vega-util';
import { COLUMN, FACET, ROW } from '../channel';
import { boxPlotNormalizer } from '../compositemark/boxplot';
import { errorBandNormalizer } from '../compositemark/errorband';
import { errorBarNormalizer } from '../compositemark/errorbar';
import { channelHasField } from '../encoding';
import * as log from '../log';
import { isFacetMapping } from '../spec/facet';
import { SpecMapper } from '../spec/map';
import { isUnitSpec } from '../spec/unit';
import { keys, omit } from '../util';
import { PathOverlayNormalizer } from './pathoverlay';
import { RuleForRangedLineNormalizer } from './ruleforrangedline';
export var CoreNormalizer = /*#__PURE__*/function (_SpecMapper) {
  _inherits(CoreNormalizer, _SpecMapper);

  function CoreNormalizer() {
    var _this;

    _classCallCheck(this, CoreNormalizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CoreNormalizer).apply(this, arguments));
    _this.nonFacetUnitNormalizers = [boxPlotNormalizer, errorBarNormalizer, errorBandNormalizer, new PathOverlayNormalizer(), new RuleForRangedLineNormalizer()];
    return _this;
  }

  _createClass(CoreNormalizer, [{
    key: "map",
    value: function map(spec, params) {
      // Special handling for a faceted unit spec as it can return a facet spec, not just a layer or unit spec like a normal unit spec.
      if (isUnitSpec(spec)) {
        var hasRow = channelHasField(spec.encoding, ROW);
        var hasColumn = channelHasField(spec.encoding, COLUMN);
        var hasFacet = channelHasField(spec.encoding, FACET);

        if (hasRow || hasColumn || hasFacet) {
          return this.mapFacetedUnit(spec, params);
        }
      }

      return _get(_getPrototypeOf(CoreNormalizer.prototype), "map", this).call(this, spec, params);
    } // This is for normalizing non-facet unit

  }, {
    key: "mapUnit",
    value: function mapUnit(spec, params) {
      var parentEncoding = params.parentEncoding,
          parentProjection = params.parentProjection;

      if (parentEncoding || parentProjection) {
        return this.mapUnitWithParentEncodingOrProjection(spec, params);
      }

      var normalizeLayerOrUnit = this.mapLayerOrUnit.bind(this);

      var _iterator = _createForOfIteratorHelper(this.nonFacetUnitNormalizers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var unitNormalizer = _step.value;

          if (unitNormalizer.hasMatchingType(spec, params.config)) {
            return unitNormalizer.run(spec, params, normalizeLayerOrUnit);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return spec;
    }
  }, {
    key: "mapRepeat",
    value: function mapRepeat(spec, params) {
      var _spec = spec,
          repeat = _spec.repeat;

      if (!isArray(repeat) && spec.columns) {
        // is repeat with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('repeat'));
      }

      return Object.assign({}, spec, {
        spec: this.map(spec.spec, params)
      });
    }
  }, {
    key: "mapFacet",
    value: function mapFacet(spec, params) {
      var _spec2 = spec,
          facet = _spec2.facet;

      if (isFacetMapping(facet) && spec.columns) {
        // is facet with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('facet'));
      }

      return _get(_getPrototypeOf(CoreNormalizer.prototype), "mapFacet", this).call(this, spec, params);
    }
  }, {
    key: "mapUnitWithParentEncodingOrProjection",
    value: function mapUnitWithParentEncodingOrProjection(spec, params) {
      var encoding = spec.encoding,
          projection = spec.projection;
      var parentEncoding = params.parentEncoding,
          parentProjection = params.parentProjection,
          config = params.config;
      var mergedProjection = mergeProjection({
        parentProjection: parentProjection,
        projection: projection
      });
      var mergedEncoding = mergeEncoding({
        parentEncoding: parentEncoding,
        encoding: encoding
      });
      return this.mapUnit(Object.assign({}, spec, mergedProjection ? {
        projection: mergedProjection
      } : {}, mergedEncoding ? {
        encoding: mergedEncoding
      } : {}), {
        config: config
      });
    }
  }, {
    key: "mapFacetedUnit",
    value: function mapFacetedUnit(spec, params) {
      // New encoding in the inside spec should not contain row / column
      // as row/column should be moved to facet
      var _a = spec.encoding,
          row = _a.row,
          column = _a.column,
          facet = _a.facet,
          encoding = tslib_1.__rest(_a, ["row", "column", "facet"]); // Mark and encoding should be moved into the inner spec


      var mark = spec.mark,
          width = spec.width,
          projection = spec.projection,
          height = spec.height,
          selection = spec.selection,
          _ = spec.encoding,
          outerSpec = tslib_1.__rest(spec, ["mark", "width", "projection", "height", "selection", "encoding"]);

      if (facet && (row || column)) {
        log.warn(log.message.facetChannelDropped([].concat(_toConsumableArray(row ? [ROW] : []), _toConsumableArray(column ? [COLUMN] : []))));
      }

      return this.mapFacet(Object.assign({}, outerSpec, {
        // row / column has higher precedence than facet
        facet: row || column ? Object.assign({}, row ? {
          row: row
        } : {}, column ? {
          column: column
        } : {}) : facet,
        spec: Object.assign({}, projection ? {
          projection: projection
        } : {}, {
          mark: mark
        }, width ? {
          width: width
        } : {}, height ? {
          height: height
        } : {}, {
          encoding: encoding
        }, selection ? {
          selection: selection
        } : {})
      }), params);
    }
  }, {
    key: "mapLayer",
    value: function mapLayer(spec, _a) {
      // Special handling for extended layer spec
      var parentEncoding = _a.parentEncoding,
          parentProjection = _a.parentProjection,
          otherParams = tslib_1.__rest(_a, ["parentEncoding", "parentProjection"]);

      var encoding = spec.encoding,
          projection = spec.projection,
          rest = tslib_1.__rest(spec, ["encoding", "projection"]);

      var params = Object.assign({}, otherParams, {
        parentEncoding: mergeEncoding({
          parentEncoding: parentEncoding,
          encoding: encoding
        }),
        parentProjection: mergeProjection({
          parentProjection: parentProjection,
          projection: projection
        })
      });
      return _get(_getPrototypeOf(CoreNormalizer.prototype), "mapLayer", this).call(this, rest, params);
    }
  }]);

  return CoreNormalizer;
}(SpecMapper);

function mergeEncoding(opt) {
  var parentEncoding = opt.parentEncoding,
      encoding = opt.encoding;

  if (parentEncoding && encoding) {
    var overriden = keys(parentEncoding).reduce(function (o, key) {
      if (encoding[key]) {
        o.push(key);
      }

      return o;
    }, []);

    if (overriden.length > 0) {
      log.warn(log.message.encodingOverridden(overriden));
    }
  }

  var merged = Object.assign({}, parentEncoding || {}, encoding || {});
  return keys(merged).length > 0 ? merged : undefined;
}

function mergeProjection(opt) {
  var parentProjection = opt.parentProjection,
      projection = opt.projection;

  if (parentProjection && projection) {
    log.warn(log.message.projectionOverridden({
      parentProjection: parentProjection,
      projection: projection
    }));
  }

  return projection || parentProjection;
}